import { Flex, Image } from '@chakra-ui/react'
import React from 'react'

const AddBanner = () => {
  return (
    <Flex>
        <Image src="https://m.media-amazon.com/images/G/01/Zappos/SITE-VIRTUAL-TRY-ON-HERO-2880x400.jpg" alt="addbanner" />
    </Flex>
  )
}

export default AddBanner